import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'azurecalc_notice_shown';

export default function DataNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:left-64">
      <div className="px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3" style={{ backgroundColor: 'var(--surface-container)', borderTop: '1px solid var(--outline-variant)' }}>
        <p className="text-[12px] flex-1" style={{ color: 'var(--text-tertiary)' }}>
          This site uses Google AdSense for ads. No tracking cookies are set by AzureCalc.uk. Saved estimates are stored without personal data.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <Link
            to="/privacy"
            className="text-[12px] text-[#0078d4] hover:underline whitespace-nowrap"
          >
            Privacy Policy
          </Link>
          <button
            onClick={dismiss}
            className="px-4 py-1.5 bg-[#0078d4] hover:bg-[#106ebe] text-white text-[12px] font-semibold rounded transition-colors whitespace-nowrap"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
